'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $is_ju_Map$Entry(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.cj)));
}
export { $is_ju_Map$Entry as $is_ju_Map$Entry };
function $isArrayOf_ju_Map$Entry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cj)));
}
export { $isArrayOf_ju_Map$Entry as $isArrayOf_ju_Map$Entry };
